module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAAmCAYAAABkpNNFAAAAAXNSR0IArs4c6QAAAK5JREFUaEPtmcENgCAUQz8bsASzMAITsAJDsAJT6UIaPJh4bEJSv5ZzQ+l73gyllM0+dkKM8fjSppzzfo2qtVpKyf221po9RvXeXY8aY5hGeVAoUx4szTfKlEwRCejzI8KHqmUKwkUMyxQRPlQtUxAuYlimiPChapmCcBHDMkWED1XLFISLGJYpInyoWqYgXMSwTBHhQ9UyBeEihv9jigh5WfW0df9JXHbrCy6ao064BTb6aRmV+gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page/crop/seven-to-five.png
// module id = 8HO0
// module chunks = 3